export enum GiftCardSource {
  Client = "client",
  Exchange = "exchange",
  ExchangeStock = "exchange_stock",
}
